import _core from "./core";

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

// prev/next buttons
(function (window, factory) {
  // universal module definition
  if (exports) {
    // CommonJS
    exports = factory(_core);
  } else {
    // browser global
    factory(window.Flickity);
  }
})(typeof window != "undefined" ? window : exports, function factory(Flickity) {
  const svgURI = "http://www.w3.org/2000/svg"; // -------------------------- PrevNextButton -------------------------- //

  function PrevNextButton(increment, direction, arrowShape) {
    (this || _global).increment = increment;
    (this || _global).direction = direction;
    (this || _global).isPrevious = increment === "previous";
    (this || _global).isLeft = direction === "left";

    this._create(arrowShape);
  }

  PrevNextButton.prototype._create = function (arrowShape) {
    // properties
    let element = (this || _global).element = document.createElement("button");
    element.className = `flickity-button flickity-prev-next-button ${(this || _global).increment}`;
    let label = (this || _global).isPrevious ? "Previous" : "Next"; // prevent button from submitting form https://stackoverflow.com/a/10836076/182183

    element.setAttribute("type", "button");
    element.setAttribute("aria-label", label); // init as disabled

    this.disable(); // create arrow

    let svg = this.createSVG(label, arrowShape);
    element.append(svg);
  };

  PrevNextButton.prototype.createSVG = function (label, arrowShape) {
    let svg = document.createElementNS(svgURI, "svg");
    svg.setAttribute("class", "flickity-button-icon");
    svg.setAttribute("viewBox", "0 0 100 100"); // add title #1189

    let title = document.createElementNS(svgURI, "title");
    title.append(label); // add path

    let path = document.createElementNS(svgURI, "path");
    let pathMovements = getArrowMovements(arrowShape);
    path.setAttribute("d", pathMovements);
    path.setAttribute("class", "arrow"); // rotate arrow

    if (!(this || _global).isLeft) {
      path.setAttribute("transform", "translate(100, 100) rotate(180)");
    }

    svg.append(title, path);
    return svg;
  }; // get SVG path movmement


  function getArrowMovements(shape) {
    // use shape as movement if string
    if (typeof shape == "string") return shape;
    let {
      x0,
      x1,
      x2,
      x3,
      y1,
      y2
    } = shape; // create movement string

    return `M ${x0}, 50
    L ${x1}, ${y1 + 50}
    L ${x2}, ${y2 + 50}
    L ${x3}, 50
    L ${x2}, ${50 - y2}
    L ${x1}, ${50 - y1}
    Z`;
  } // -----  ----- //


  PrevNextButton.prototype.enable = function () {
    (this || _global).element.removeAttribute("disabled");
  };

  PrevNextButton.prototype.disable = function () {
    (this || _global).element.setAttribute("disabled", true);
  }; // -------------------------- Flickity prototype -------------------------- //


  Object.assign(Flickity.defaults, {
    prevNextButtons: true,
    arrowShape: {
      x0: 10,
      x1: 60,
      y1: 50,
      x2: 70,
      y2: 40,
      x3: 30
    }
  });

  Flickity.create.prevNextButtons = function () {
    if (!(this || _global).options.prevNextButtons) return;
    let {
      rightToLeft,
      arrowShape
    } = (this || _global).options;
    let prevDirection = rightToLeft ? "right" : "left";
    let nextDirection = rightToLeft ? "left" : "right";
    (this || _global).prevButton = new PrevNextButton("previous", prevDirection, arrowShape);
    (this || _global).nextButton = new PrevNextButton("next", nextDirection, arrowShape);

    (this || _global).focusableElems.push((this || _global).prevButton.element);

    (this || _global).focusableElems.push((this || _global).nextButton.element);

    (this || _global).handlePrevButtonClick = () => {
      this.uiChange();
      this.previous();
    };

    (this || _global).handleNextButtonClick = () => {
      this.uiChange();
      this.next();
    };

    this.on("activate", (this || _global).activatePrevNextButtons);
    this.on("select", (this || _global).updatePrevNextButtons);
  };

  let proto = Flickity.prototype;

  proto.updatePrevNextButtons = function () {
    let lastIndex = (this || _global).slides.length ? (this || _global).slides.length - 1 : 0;
    this.updatePrevNextButton((this || _global).prevButton, 0);
    this.updatePrevNextButton((this || _global).nextButton, lastIndex);
  };

  proto.updatePrevNextButton = function (button, disabledIndex) {
    // enable is wrapAround and at least 2 slides
    if ((this || _global).isWrapping && (this || _global).slides.length > 1) {
      button.enable();
      return;
    }

    let isEnabled = (this || _global).selectedIndex !== disabledIndex;
    button[isEnabled ? "enable" : "disable"](); // if disabling button that is focused,
    // shift focus to element to maintain keyboard accessibility

    let isDisabledFocused = !isEnabled && document.activeElement === button.element;
    if (isDisabledFocused) this.focus();
  };

  proto.activatePrevNextButtons = function () {
    (this || _global).prevButton.element.addEventListener("click", (this || _global).handlePrevButtonClick);

    (this || _global).nextButton.element.addEventListener("click", (this || _global).handleNextButtonClick);

    (this || _global).element.append((this || _global).prevButton.element, (this || _global).nextButton.element);

    this.on("deactivate", (this || _global).deactivatePrevNextButtons);
  };

  proto.deactivatePrevNextButtons = function () {
    (this || _global).prevButton.element.remove();

    (this || _global).nextButton.element.remove();

    (this || _global).prevButton.element.removeEventListener("click", (this || _global).handlePrevButtonClick);

    (this || _global).nextButton.element.removeEventListener("click", (this || _global).handleNextButtonClick);

    this.off("deactivate", (this || _global).deactivatePrevNextButtons);
  }; // --------------------------  -------------------------- //


  Flickity.PrevNextButton = PrevNextButton;
  return Flickity;
});

export default exports;